import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import NewMessageBar from 'messaging/components/NewMessageBar';
import {
  openDiffusionModal,
  clearUserSelection,
  onUserSelected,
  closeDiffusionModal,
} from '../actions/diffusion';
import { isModalOpened, getSelectedUsers } from '../reducers/diffusion';
import { sendMessage } from 'messaging/actions/message';
import DiffusionModal from 'modules/diffusion/components/DiffusionModal';
import DiffusionList from '../components/DiffusionList';
import DiffusionHeader from '../components/DiffusionHeader';

const mapStateToProps = state => ({
  isModalOpened: isModalOpened(state),
  isSending: state.messaging.mailbox.isSending,
  selectedUsers: getSelectedUsers(state),
});

const mapDispatchToProps = dispatch => ({
  sendMessage: (message, to) => dispatch(sendMessage(message, to)),
  openDiffusionModal: () => dispatch(openDiffusionModal()),
  closeDiffusionModal: () => dispatch(closeDiffusionModal()),
  clearUserSelection: () => dispatch(clearUserSelection()),
  onUserSelected: datas => dispatch(onUserSelected(datas.selectedUsers)),
});

class DiffusionPage extends React.Component {
  static propTypes = {
    isSending: PropTypes.bool,
    tags: PropTypes.array,
    isModalOpened: PropTypes.bool,
    sendMessage: PropTypes.func.isRequired,
    openDiffusionModal: PropTypes.func.isRequired,
    closeDiffusionModal: PropTypes.func.isRequired,
    clearUserSelection: PropTypes.func.isRequired,
    onUserSelected: PropTypes.func.isRequired,
    selectedUsers: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    props.clearUserSelection();
    this.onSendMessage = this.onSendMessage.bind(this);
  }

  onSendMessage(message) {
    const selected = this.props.selectedUsers.map(r => r.id);
    if (selected.length > 0) {
      this.props.sendMessage(message, selected);
    }
  }

  render() {
    const {
      isModalOpened,
      isSending,
      openDiffusionModal,
      closeDiffusionModal,
      selectedUsers,
      clearUserSelection,
      onUserSelected,
    } = this.props;

    return (
      <div className="newMessage ui tab active">
        <div className="container">
          <div className="ui segments">
            <DiffusionHeader
              selectedUsers={selectedUsers}
              openModal={openDiffusionModal}
              clearSelection={clearUserSelection}
            />
            <DiffusionList users={selectedUsers} />
            <NewMessageBar
              canSend={selectedUsers.length > 0}
              isSending={isSending}
              onSend={this.onSendMessage}
            />
            <DiffusionModal
              id="modal-diffusion"
              name="diffusion"
              title="Ajout de destinataires"
              isOpened={isModalOpened}
              validationCallback={onUserSelected}
              cancelCallback={closeDiffusionModal}
              selectable
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiffusionPage);



// WEBPACK FOOTER //
// ./src/modules/messaging/pages/DiffusionPage.js